import React, {useEffect, useState} from 'react';
import Portal from "../../../utils/Portal";
import {axiosPrivate} from "../../../api/PrivateRequestServices";

function EditEmployee(prop) {
    const [name, setName] = useState(prop.data.firstname + " " + prop.data.lastname);
    const [designation, setDesignation] = useState(prop.data.designation);
    const [showDrop, setShowDrop] = useState(false);
    const [roleValue, setRoleValue] = useState((prop.data.is_root=="Y" ? "super_admin" : "admin"))  ;
    const [message, setMessage] = useState('');

    let capitalizeName = (name) =>{
        const fullName = name;
        const names = fullName.split(" ");
        const capitalizedNames = names.map(name => name.charAt(0).toUpperCase() + name.slice(1));
        const formattedName = capitalizedNames.join(" ");
        return formattedName;
    }
    let removeSpace = (data) => {
        //for removing space from start of name
        if(/^\s/.test(data)){
            return data.slice(1);
            // setName(prevState => prevState.slice(1));
        }
        return data;
    }
    let editEmp = async () => {
        setMessage("");
        try{
            let payload = {};
            payload.user_id = prop.data.user_id;
            payload.user_data = {};
            payload.user_data.name = capitalizeName(removeSpace(name));
            payload.user_data.designation = designation;
            payload.user_data.privilege = roleValue;
            const res = await axiosPrivate.post( process.env.REACT_APP_EDIT_USER_URL, payload);
            if(res?.status == 200){
                setMessage(res?.message);
                prop.close(true);
            }
            else{

            }
        }
        catch(err){
            console.log(err);
        }
    }
    const onSubmit = (e) => {
        e.preventDefault();

        //for removing space from start of name
        if(/^\s/.test(name)){
            setName(prevState => prevState.slice(1));
        }
        if(name != " " && name != null && name != ""){
            editEmp();
        }
        else{
            setMessage("Name not valid");
            setName("");
        }
    }
    function handleDesignationChange(event) {
        const regex = /^[a-zA-Z0-9\s-]*$/;
        const newValue = event.target.value;
        if (regex.test(newValue)) {
            setDesignation(newValue);
        }
    }

    return (
        <Portal>
            <div id="myModal" className="popup_box open">
                <div className="model_box">
                    <div
                        className="model_box_child prd_ns"
                        id="prd_ns"
                        style={{ maxWidth: 570 }}
                    >
                        <div className="ap_heading">
                            <h4>
                                Edit employee details {" "}
                                <span className="material-symbols-rounded black close_model" onClick={()=>prop.close(false)}>
                                    close
                                </span>
                            </h4>
                        </div>
                        <div className="contentSection">
                            <section className="b_section dForm empFormPop">
                                <div className="fieldGroup mt-0">
                                    <label>Employee name</label>
                                    <span>
                                        <input
                                            type="text"
                                            placeholder="Enter full name"
                                            required
                                            onChange={(e) => {setName(e.target.value.replace(/[^A-Za-z]+$/ig  , " "))}}
                                            value={name}/>
                                    </span>
                                </div>
                                <div className="fieldGroup mt-0">
                                    <label>Employee designation</label>
                                    <span>
                                        <input
                                            type="text"
                                            placeholder="Enter designation"
                                            onChange={handleDesignationChange}
                                            value={designation}
                                        />
                                    </span>
                                </div>
                                <div className="fieldGroup">
                                    <label>Official email ID</label>
                                    <span>
                                        <input
                                            type="text"
                                            placeholder="Enter official email ID"
                                            value={prop.data.email}
                                            disabled
                                        />
                                    </span>
                                </div>
                                <div className="fieldGroup">
                                    <label>Select role</label>
                                    <div className="multiOption">
                                        <div className={showDrop ? "selectBox fullW open" : "selectBox fullW"} onClick={()=>{setShowDrop(prev => !prev)}}>
                                            {roleValue == ''
                                                ?
                                                <p>
                                                    Select user role{" "}
                                                    <i className="material-symbols-rounded grey">expand_more</i>
                                                </p>
                                                :
                                                (
                                                    roleValue == "admin" ?
                                                        <p>
                                                            Admin
                                                            <i className="material-symbols-rounded grey">expand_more</i>
                                                        </p>
                                                        :
                                                        <p>
                                                            Super Admin
                                                            <i className="material-symbols-rounded grey">expand_more</i>
                                                        </p>

                                                )
                                            }
                                            <div className="selectDrop">
                                                <ul className="dropMenu">
                                                    <li className="selected" onClick={(e)=>{e.preventDefault(); setRoleValue("admin")}}>
                                                        <a href={void(0)}>
                                                            Admin
                                                            {roleValue == "admin" && <i className="material-symbols-rounded">done</i>}
                                                        </a>
                                                    </li>
                                                    <li onClick={(e)=>{ e.preventDefault(); setRoleValue("super_admin")}}>
                                                        <a href={void(0)}>
                                                            Super Admin
                                                            {roleValue == "super_admin" && <i className="material-symbols-rounded">done</i>}
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="fieldGroup mobileVerfiy">
                                    <label>Mobile number</label>
                                    <span>
                                        <input
                                            type="text"
                                            value={prop.data.phone}
                                            className="disable"
                                            disabled
                                        />
                                    </span>
                                </div>
                            </section>
                            {message != "" &&
                                <span style={{color:"red"}}>
                                    {message}
                                </span>}
                            <div className="actionButtons mt-8">
                                <span onClick={onSubmit}>
                                    <a href={void(0)} onClick={e=>e.preventDefault()} className="btn prim" >
                                      Update Details
                                    </a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </Portal>

    );
}

export default EditEmployee;